class PdpBenches extends HTMLElement {
  connectedCallback() {
    this.headingValue = this.querySelector('[data-bench-heading-value]');
    this.modal = this.querySelector('[data-bench-modal]');
    this.modalImage = this.querySelector('[data-bench-modal-image]');
    this.modalTitle = this.querySelector('[data-bench-modal-title]');
    this.modalDescription = this.querySelector('[data-bench-modal-description]');
    this.cards = Array.from(this.querySelectorAll('[data-bench-card]'));
    this.optionPosition = this.dataset.optionPosition;

    this.onClick = this.onClick.bind(this);
    this.onDocClick = this.onDocClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onNativeChange = this.onNativeChange.bind(this);

    this.addEventListener('click', this.onClick, true);
    document.addEventListener('click', this.onDocClick);
    document.addEventListener('keydown', this.onKeyDown);

    this.variantSelects =
      this.closest('product-component')?.querySelector('variant-selects') ||
      document.querySelector('variant-selects');

    if (this.variantSelects) {
      this.variantSelects.addEventListener('change', this.onNativeChange);
      this.hideNativeOption();
    }

    if (this.modal && this.modal.parentElement !== document.body) {
      document.body.appendChild(this.modal);
    }

    this.syncFromNative();
  }

  hideNativeOption() {
    if (!this.variantSelects || !this.optionPosition) return;

    this.variantSelects.querySelectorAll('.VariantSelect').forEach((group) => {
      const input = group.querySelector(
        `input.inputSelectboxCheckbox[name="${CSS.escape(this.optionPosition)}"]`
      );
      if (!input) return;
      group.hidden = true;
      group.setAttribute('aria-hidden', 'true');
      group.classList.add('pdp-benches-native-option');
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick, true);
    document.removeEventListener('click', this.onDocClick);
    document.removeEventListener('keydown', this.onKeyDown);
    this.variantSelects?.removeEventListener('change', this.onNativeChange);
    document.body.classList.remove('pdp-benches-modal-open');
    if (this.modal && this.modal.parentElement === document.body) {
      this.modal.remove();
    }
  }

  getNativeRadios() {
    if (!this.variantSelects || !this.optionPosition) return [];
    return Array.from(
      this.variantSelects.querySelectorAll(
        `input.inputSelectboxCheckbox[name="${CSS.escape(this.optionPosition)}"]`
      )
    );
  }

  onNativeChange(event) {
    if (!event.target?.classList?.contains('inputSelectboxCheckbox')) return;
    if (String(event.target.name) !== String(this.optionPosition)) return;
    this.syncFromNative();
  }

  syncFromNative() {
    const radios = this.getNativeRadios();
    const checked = radios.find((radio) => radio.checked) || null;

    this.cards.forEach((card) => {
      const inputId = card.getAttribute('for');
      const input = inputId ? document.getElementById(inputId) : null;
      card.classList.toggle('is-selected', Boolean(input?.checked));
    });

    if (this.headingValue && checked) {
      const selectedCard = this.cards.find((card) => card.getAttribute('for') === checked.id);
      this.headingValue.textContent =
        selectedCard?.dataset.headingTitle || checked.value || '';
    }
  }

  onClick(event) {
    const infoButton = event.target.closest('[data-bench-info]');
    if (!infoButton || !this.contains(infoButton)) return;

    event.preventDefault();
    event.stopPropagation();
    const card = infoButton.closest('[data-bench-card]');
    if (card) this.openModal(card);
  }

  onDocClick(event) {
    if (!this.modal?.classList.contains('is-open')) return;
    if (event.target.closest('[data-bench-modal-close]')) {
      event.preventDefault();
      this.closeModal();
    }
  }

  onKeyDown(event) {
    if (event.key === 'Escape' && this.modal?.classList.contains('is-open')) {
      this.closeModal();
    }
  }

  openModal(card) {
    if (!this.modal) return;
    const descriptionTemplate = card.querySelector('[data-bench-popup-description]');

    if (this.modalTitle) {
      this.modalTitle.textContent = card.dataset.popupTitle || '';
    }

    if (this.modalImage) {
      const imageUrl = card.dataset.popupImage;
      const imageRatio = card.dataset.popupImageRatio || '16/10';
      this.modalImage.style.setProperty('--pdp-benches-popup-image-ratio', imageRatio);
      this.modalImage.innerHTML = imageUrl
        ? `<img src="${imageUrl}" alt="${this.escapeHtml(card.dataset.popupTitle || '')}" loading="lazy">`
        : '';
    }

    if (this.modalDescription) {
      this.modalDescription.innerHTML = descriptionTemplate ? descriptionTemplate.innerHTML : '';
    }

    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pdp-benches-modal-open');
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pdp-benches-modal-open');
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}

if (!customElements.get('pdp-benches')) {
  customElements.define('pdp-benches', PdpBenches);
}
